export const client_secret = "2ByjqXGjeiaaBEvWYeV84Tpz4bPTOabUiISSyhtr";
export const client_id = "2";
export const grant_type = "password";
